import color from 'color';

export default (c, a) => color(c).alpha(a).string();
